import React, { useState, useEffect } from 'react';
import { Card, Table, message, Tag, Button, Space } from 'antd';
import { UserOutlined, CheckCircleOutlined, ClockCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import api from '../utils/axios';
import { useAuth } from '../contexts/AuthContext';

const LearningRecords = () => {
  const { user } = useAuth();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLearningRecords();
  }, []);

  const fetchLearningRecords = async () => {
    setLoading(true);
    try {
      const response = await api.get('/learning/records');
      if (response.data && response.data.success) {
        setRecords(response.data.data || []);
      }
    } catch (error) {
      message.error('获取学习记录失败');
      console.error('获取学习记录失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const recordColumns = [
    {
      title: '课程名称',
      dataIndex: 'course_name',
      key: 'course_name'
    },
    {
      title: '课程类型',
      dataIndex: 'course_type',
      key: 'course_type',
      render: (type) => (
        <Tag color={type === '管理课' ? 'blue' : 'green'}>
          {type}
        </Tag>
      )
    },
    {
      title: '状态',
      key: 'status',
      render: (_, record) => (
        <Tag color={record.completed ? 'green' : 'blue'}>
          {record.completed ? (
            <>
              <CheckCircleOutlined /> 已完成
            </>
          ) : (
            <>
              <ClockCircleOutlined /> 进行中
            </>
          )}
        </Tag>
      )
    },
    {
      title: '开始时间',
      dataIndex: 'started_at',
      key: 'started_at',
      render: (startedAt) => new Date(startedAt).toLocaleString()
    },
    {
      title: '完成时间',
      dataIndex: 'completed_at',
      key: 'completed_at',
      render: (completedAt) => completedAt ? new Date(completedAt).toLocaleString() : '未完成'
    }
  ];

  return (
    <div className="learning-records-container" style={{ padding: '10px 16px' }}>
      <div className="learning-records-header" style={{ marginBottom: '20px' }}>
        <h1 style={{ fontSize: '24px', margin: 0 }}>学习记录</h1>
      </div>

      {/* 学习记录 */}
      <Card style={{ marginBottom: '20px' }} title={
        <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>我的学习记录</span>
          <Button icon={<ReloadOutlined />} onClick={fetchLearningRecords} loading={loading}>
            刷新
          </Button>
        </Space>
      }>
        <Table
          columns={recordColumns}
          dataSource={records}
          rowKey="id"
          loading={loading}
        />
      </Card>
    </div>
  );
};

export default LearningRecords;